import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root',
})
export class ProjetoVisualizadoService extends ApiConfig {
  promise: Promise<unknown>;
  constructor(private http: HttpClient) {
    super();
  }

  listar(login) {
    try {
      if(this.promise) {
        return this.promise;
      }
      this.promise = new Promise(async (resolve) => {
        this.http
          .get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoVisualizadoUsuario/ListarPorUsuarioGet?usuario=' + login)
          .subscribe(
            (data) => {
              resolve(data);
              this.promise = null;
            },
            (error) => {
              this.promise = null;
            }
          );
      });
      return this.promise;
    } catch (error) {
      alert(error);
    }
  }
}
